"use client";
import { Switch } from "antd";

import CommonSearchMobile from "app/(new-pages)/components/Search/mobile/index.mobile";
import useSearch, { handleFilterSuggestionList } from "../useSearch";
import FilterMobile from "../../Filters/mobile/index.mobile";

import styles from "../../../style/index.mobile.module.scss";
import LocationSelectMobile from "app/(new-pages)/components/allSelect/LocationSelect/mobile";
import classNames from "classnames";
import Web3JobFunctionSelectMobile from "app/(new-pages)/components/allSelect/Web3JobFunctionSelect/mobile/index.mobile";
import SingleSelectMobile from "app/(new-pages)/components/allSelect/baseSelect/mobiles/SingleSelect";
import JobFunctionSelectMobile from "app/(new-pages)/components/allSelect/JobFunctionSelect/mobile/index.mobile";
import { formatTemplateString } from "helpers/formatter";

const SearchMobile = ({ config, searchParams, params, dictionary }) => {
  const {
    query,
    setQuery,
    reload,
    input_text,
    suggestionList,

    sortFilter,
    locationValue,
    setLocationValue,
    jobFunction,
    setJobFunction,
    handleClearAll,
    sort,
    setSort,

    moreFilterData,
    setMoreFilterData,

    salary,
    setSalary
  } = useSearch(config, searchParams, params);

  const {
    location_filter = [],
    main_function_filter = [],
    job_function_h5_text,
    search_country_text,
    open_country_region_h5_text,
    search_job_function_text,
    location_text,
    location_search_text
  } = config;

  const { connect_text, input_text_v2 } = config;

  const inputPlaceholder = formatTemplateString(input_text_v2, {
    connect_text: `<span>${connect_text}</span>`
  });
  const placeholder = <span dangerouslySetInnerHTML={{ __html: inputPlaceholder }}></span>;

  console.log("config", config);

  return (
    <div className={styles.search}>
      <CommonSearchMobile
        setQuery={setQuery}
        query={query}
        placeholder={placeholder}
        suggestionList={suggestionList}
        onSearch={reload}
        setLocationValue={setLocationValue}
        inputOptions={{
          companyGroupText: dictionary?.remotePage?.companyGroupText,
          jobTitleGroupText: dictionary?.remotePage?.jobTitleGroupText,
          historyGroupText: dictionary?.remotePage?.historyGroupText,
          popularJobsText: dictionary?.remotePage?.popularJobsText
        }}
      />

      <div className={styles.filter}>
        <div className={classNames({ [styles.defaultFiled]: true })}>
          <LocationSelectMobile
            location_filter={location_filter}
            value={locationValue}
            onChange={setLocationValue}
            search_country_text={location_search_text}
            location_text={location_text}
          />
        </div>

        <div className={classNames({ [styles.defaultFiled]: true })}>
          <JobFunctionSelectMobile
            main_function_filter={main_function_filter}
            value={jobFunction}
            onChange={setJobFunction}
            jobFunctionText={config?.main_function_text}
            searchJobFunctionText={config?.main_function_search_text}
          />
        </div>

        <div className={classNames({ [styles.defaultFiled]: true })}>
          <SingleSelectMobile
            options={sortFilter}
            variant='borderless'
            value={sort}
            onChange={setSort}
          />
        </div>

        <div className={classNames({ [styles.defaultFiled]: true })}>
          <FilterMobile
            config={config}
            handleClearAll={handleClearAll}
            reload={reload}
            moreFilterData={moreFilterData}
            setMoreFilterData={setMoreFilterData}
            salary={salary}
            setSalary={setSalary}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchMobile;
